import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeNavigateStore = {
  /** 페이지 이동 blocking 여부 */
  isLocationPop: boolean;
  /** 뒤로가기 클릭 여부 */
  isNavigateBlocking: boolean;
  actions: {
    /** 뒤로가기 클릭 여부 상태 변경 */
    setIsLocationPop: (isLocationPop: boolean) => void;
    /** 페이지 이동 blocking 상태 변경 */
    setIsNavigateBlocking: (isNavigateBlocking: boolean) => void;
  };
};

/** @description 페이지 이동 blocking 여부 및 뒤로가기 클릭 여부를 관리하는 상태 */
export const useNavigateStore = create<TypeNavigateStore>()(
  devtools((set) => ({
    isLocationPop: false,
    isNavigateBlocking: false,
    actions: {
      setIsLocationPop: (isLocationPop) => set({ isLocationPop }),
      setIsNavigateBlocking: (isNavigateBlocking) => set({ isNavigateBlocking }),
    },
  }))
);
